import React, { useState } from 'react';
import { X } from 'lucide-react';
import { galleryImages } from '@/lib/config';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [filter, setFilter] = useState('all');

  const categories = [
    { id: 'all', label: 'All' },
    { id: 'resort', label: 'Resort' },
    { id: 'rooms', label: 'Rooms' },
    { id: 'pool', label: 'Pool' },
    { id: 'dining', label: 'Dining' },
    { id: 'farmland', label: 'Farmland' }
  ];

  const filteredImages = filter === 'all'
    ? galleryImages
    : galleryImages.filter(img => img.category === filter);

  return (
    <section id="gallery" className="gallery-section">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">Photo Gallery</h2>
          <p className="section-subtitle">
            Explore the beauty and elegance of Luxtansa Resorts
          </p>
        </div>

        <div className="gallery-filters">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => setFilter(category.id)}
              className={`gallery-filter-button ${
                filter === category.id ? 'active' : ''
              }`}
            >
              {category.label}
            </button>
          ))}
        </div>

        <div className="gallery-grid">
          {filteredImages.map((image) => (
            <div
              key={image.id}
              className="gallery-item"
              onClick={() => setSelectedImage(image)}
            >
              <img src={image.url} alt={image.title} className="gallery-image" />
              <div className="gallery-overlay">
                <span className="gallery-title">{image.title}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {selectedImage && (
        <div className="lightbox" onClick={() => setSelectedImage(null)}>
          <button className="lightbox-close" onClick={() => setSelectedImage(null)}>
            <X size={32} />
          </button>
          <img
            src={selectedImage.url}
            alt={selectedImage.title}
            className="lightbox-image"
            onClick={(e) => e.stopPropagation()}
          />
          <p className="lightbox-caption">{selectedImage.title}</p>
        </div>
      )}
    </section>
  );
};

export default Gallery;
